export function isNull(value: any): boolean {
  return value === null
}

export function isUndefined(value: any): boolean {
  return value === undefined
}

export function isEmpty(value: any): boolean {
  return isNull(value) || isUndefined(value)
}

export function equalsObjects<T = object>(obj1: T, obj2: T, deep = false): boolean {
  if (obj1 === obj2) return true
  const keys1 = Object.keys(obj1)
  const keys2 = Object.keys(obj2)
  if (keys1.length !== keys2.length) return false
  for (let i = 0; i < keys1.length; i++) {
    const key = keys1[i]
    if (!keys2.includes(key)) return false
    const value1 = obj1[key]
    const value2 = obj2[key]
    if (deep) {
      if (typeof value1 !== typeof value2) return false
      if (typeof value1 === 'object') {
        const res = equalsObjects(value1, value2, deep)
        if (!res) return false
      } else {
        if (value1 !== value2) return false
      }
    } else {
      if (value1 !== value2) return false
    }
  }
  return true
}

export function isEmptyObject(obj: object): boolean {
  if (isEmpty(obj)) return true
  const keys = Object.keys(obj)
  return !keys.length

}
